var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4171: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators-webpack_sharing_consume-3b05cf"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(7404))))))),
	4005: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,18,2,9], () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs").then(() => (() => (__webpack_require__(316))))))),
	7343: () => (loadStrictSingletonVersion("default", "rxjs", false, [4,7,8,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_tslib_tslib"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(1340))))))),
	3435: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [4,7,8,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_tslib_tslib"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(3620))))))),
	4659: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators-webpack_sharing_consume-3b05cf"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(6443))))))),
	1327: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_animations_fesm2022_animations_mjs")]).then(() => (() => (__webpack_require__(7172))))))),
	937: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(436))))))),
	2663: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [4,18,2,10], () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs").then(() => (() => (__webpack_require__(9168))))))),
	4681: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [4,18,2,10], () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_overlay_mjs").then(() => (() => (__webpack_require__(4512))))))),
	4183: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [4,18,2,9], () => (__webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs").then(() => (() => (__webpack_require__(4456))))))),
	4910: () => (loadStrictSingletonVersion("default", "tslib", false, [4,2,4,1], () => (__webpack_require__.e("node_modules_tslib_tslib_es6_js").then(() => (() => (__webpack_require__(7824))))))),
	7081: () => (loadStrictSingletonVersion("default", "@spp/common", false, [4,0,0,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-f440fb"), __webpack_require__.e("default-target_libraries_spp_common_fesm2022_spp-common_mjs")]).then(() => (() => (__webpack_require__(8363))))))),
	5553: () => (loadStrictSingletonVersion("default", "@angular/router", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(5072))))))),
	5189: () => (loadStrictSingletonVersion("default", "@angular/platform-browser/animations", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(3835))))))),
	1305: () => (loadStrictSingletonVersion("default", "@spp/oauth", false, [4,0,0,1], () => (__webpack_require__.e("default-target_libraries_spp_oauth_fesm2022_spp-oauth_mjs").then(() => (() => (__webpack_require__(4943))))))),
	3691: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [4,18,2,9], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs")]).then(() => (() => (__webpack_require__(655)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		4171
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		4005
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators-webpack_sharing_consume-3b05cf": [
		7343,
		3435
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		4659
	],
	"default-webpack_sharing_consume_default_angular_animations_angular_animations": [
		1327
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		937
	],
	"default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal": [
		2663
	],
	"default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-f440fb": [
		4681,
		4183
	],
	"default-webpack_sharing_consume_default_tslib_tslib": [
		4910
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router-webpack_sharing_consume-07a77b": [
		7081,
		5553
	],
	"bootstrap_ts": [
		5189,
		1305
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		3691
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}